export default __webpack_public_path__ + "static/media/Congo.41c59f7e.png";